(function () {
  var DESKTOP_MQ = window.matchMedia("(min-width: 960px)");

  function qs(root, selector) {
    return (root || document).querySelector(selector);
  }

  function qsa(root, selector) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function headerBottom() {
    var header = qs(document, ".header-container") || qs(document, "[data-component='header']");
    if (!header) return 0;
    return Math.round(header.getBoundingClientRect().bottom);
  }

  function positionDesktop() {
    var header = qs(document, ".header--nav-v2");
    if (!header) return;
    var dropdownTop = headerBottom();
    header.style.setProperty("--nav-v2-dropdown-top", dropdownTop + "px");
    var bar = qs(document, "[data-nav-v2-bar]");
    var navBottom = bar ? Math.round(bar.getBoundingClientRect().bottom) : dropdownTop;
    header.style.setProperty("--nav-v2-nav-bottom", navBottom + "px");
    if (!bar) return;
    var rect = bar.getBoundingClientRect();
    var left = Math.round(rect.left);
    var width = Math.round(rect.width);
    header.style.setProperty("--nav-v2-bar-left", left + "px");
    header.style.setProperty("--nav-v2-bar-width", width + "px");
    header.style.setProperty("--nav-v2-bar-center", Math.round(left + width / 2) + "px");
  }

  function positionMobile() {
    var mobile = qs(document, "[data-nav-v2-mobile]");
    if (!mobile) return;
    mobile.style.top = headerBottom() + "px";
  }

  function closeMobile() {
    var mobile = qs(document, "[data-nav-v2-mobile]");
    document.body.classList.remove("nav-v2-open");
    qsa(document, "[data-nav-v2-panel]").forEach(function (panel) {
      panel.classList.remove("is-open");
      panel.setAttribute("aria-hidden", "true");
    });
    if (mobile) mobile.classList.remove("is-drilled");
  }

  function openMobile() {
    positionMobile();
    document.body.classList.add("nav-v2-open");
  }

  function openPanel(handle) {
    var mobile = qs(document, "[data-nav-v2-mobile]");
    qsa(document, "[data-nav-v2-panel]").forEach(function (panel) {
      var match = panel.getAttribute("data-nav-v2-panel") === handle;
      panel.classList.toggle("is-open", match);
      panel.setAttribute("aria-hidden", match ? "false" : "true");
    });
    if (mobile) mobile.classList.add("is-drilled");
  }

  function closePanel() {
    var mobile = qs(document, "[data-nav-v2-mobile]");
    qsa(document, "[data-nav-v2-panel]").forEach(function (panel) {
      panel.classList.remove("is-open");
      panel.setAttribute("aria-hidden", "true");
    });
    if (mobile) mobile.classList.remove("is-drilled");
  }

  function assemble() {
    var mobile = qs(document, "[data-nav-v2-mobile]");
    if (!mobile) return;

    var subs = qs(mobile, "[data-nav-v2-subs]");
    qsa(mobile, "[data-nav-v2-categories] [data-nav-v2-panel]").forEach(function (panel) {
      if (subs) subs.appendChild(panel);
    });
  }

  function isNewMenuEnabled() {
    return Boolean(qs(document, ".header--nav-v2"));
  }

  function bindMobile() {
    var openBtn = qs(document, "#mobile-nav");
    var closeBtn = qs(document, "#mobile-nav-close");

    if (openBtn) {
      openBtn.addEventListener(
        "click",
        function (event) {
          if (!isNewMenuEnabled()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          openMobile();
        },
        true
      );
    }

    if (closeBtn) {
      closeBtn.addEventListener(
        "click",
        function (event) {
          if (!isNewMenuEnabled()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          closeMobile();
        },
        true
      );
    }

    qsa(document, "[data-nav-v2-open]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        openPanel(btn.getAttribute("data-nav-v2-open"));
      });
    });

    qsa(document, "[data-nav-v2-back]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        closePanel();
      });
    });
  }

  function bindGlobal() {
    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      closeMobile();
    });

    window.addEventListener("resize", function () {
      positionDesktop();
      positionMobile();
      if (DESKTOP_MQ.matches) closeMobile();
    });

    window.addEventListener("scroll", positionDesktop, { passive: true });
  }

  function bindCompactFeatured() {
    qsa(document, '.nav-v2-dropdown--compact, .nav-v2-dropdown[data-layout="compact"]').forEach(function (dropdown) {
      var panel = qs(dropdown, '[data-nav-v2-featured-panel]');
      if (!panel) return;

      var img = qs(panel, '.nav-v2-desk-featured__image');
      var titleEl = qs(panel, '[data-nav-v2-featured-title]');
      var subtitleEl = qs(panel, '[data-nav-v2-featured-subtitle]');

      function readDefault() {
        return {
          href: panel.getAttribute('data-nav-v2-featured-default-href') || panel.getAttribute('href') || '',
          src: panel.getAttribute('data-nav-v2-featured-default-src') || (img ? img.getAttribute('src') : '') || '',
          title: panel.getAttribute('data-nav-v2-featured-default-title') || (titleEl ? titleEl.textContent : '') || '',
          subtitle:
            panel.getAttribute('data-nav-v2-featured-default-subtitle') ||
            (subtitleEl ? subtitleEl.textContent : '') ||
            ''
        };
      }

      var defaults = readDefault();

      function applyFeatured(data) {
        if (img && data.src) {
          img.setAttribute('src', data.src);
          img.removeAttribute('srcset');
          if (data.title) img.setAttribute('alt', data.title);
        }
        if (titleEl) titleEl.textContent = data.title || '';
        if (subtitleEl) {
          subtitleEl.textContent = data.subtitle || '';
          if (data.subtitle) {
            subtitleEl.removeAttribute('hidden');
          } else {
            subtitleEl.setAttribute('hidden', '');
          }
        }
        if (panel.tagName === 'A' && data.href) {
          panel.setAttribute('href', data.href);
        }
      }

      qsa(dropdown, '.nav-v2-desk-link').forEach(function (link) {
        link.addEventListener('mouseenter', function () {
          var src = link.getAttribute('data-nav-v2-featured-src');
          if (!src) {
            applyFeatured(defaults);
            return;
          }
          applyFeatured({
            src: src,
            title: link.getAttribute('data-nav-v2-featured-title') || '',
            subtitle: link.getAttribute('data-nav-v2-featured-subtitle') || '',
            href: link.getAttribute('data-nav-v2-featured-href') || link.getAttribute('href') || ''
          });
        });
      });

      dropdown.addEventListener('mouseleave', function () {
        applyFeatured(defaults);
      });
    });
  }

  function init() {
    if (!qs(document, ".header--nav-v2")) return;
    assemble();
    bindMobile();
    bindCompactFeatured();
    bindGlobal();
    positionDesktop();
    positionMobile();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
